const pagesGrid = {
  display: 'flex',
  alignItems: 'center',
  gap: '2rem',
  justifyContent: 'flex-start',
};

const buttonsGrid = {
  display: 'flex',
  alignItems: 'center',
  justifySelf: 'flex-end',
  justifyContent: 'flex-end',
};

const navbarButton = (theme) => ({
  marginLeft: '1rem',
  padding: '0.5rem',
  border: `2px solid ${theme.palette.primary.main}`,
  minWidth: '8rem',
});

const buttonTypography = {
  fontWeight: 600,
  textTransform: 'none',
};

export {
  pagesGrid,
  buttonsGrid,
  navbarButton,
  buttonTypography,
};
